import i18next from "i18next";
import I18NextVue from "i18next-vue";
import type { App } from "vue";
import { currentBrand } from "@/brand";

const modules = import.meta.glob("./*/**/*.json", { eager: true });
const resources: Record<string, Record<string, any>> = {};

for (const path in modules) {
  const match = path.match(/\.\/(\w+)\/([\w-]+)\.json$/);
  if (!match) continue;
  const [, lang, ns] = match;
  const content = (modules[path] as any).default;

  if (!resources[lang]) resources[lang] = {};
  resources[lang][ns] = content;
}

i18next.init({
  lng: "fr",
  ns: [
    "common",
    "dashboard",
    "report",
    "auth",
    "backoffice",
    "canvas",
    "toast",
    "catalogue",
  ],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
    // Le nom du produit dépend du domaine servi. On l'expose à TOUTES les
    // traductions, plutôt que de le passer à chaque appel de `t()` : toute
    // chaîne peut utiliser {{brand}} (nom complet) ou {{brandShort}} (nom
    // court, sous l'icône d'app par exemple) sans rien câbler côté composant.
    defaultVariables: {
      brand: currentBrand.name,
      brandShort: currentBrand.shortName,
    },
  },
  fallbackLng: false,
  resources,
});

export function setupI18n(app: App) {
  app.use(I18NextVue, { i18next });
}
